import React, { useCallback } from 'react';
import { Model, useMetaContext, errorCatch, GET, POSTFormData, CollectionServer, updateInArray, If, makeFormData } from 'fennec-ui';
import { Button, Modal, Tag } from 'antd';
import Icofont from 'react-icofont';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import RassilkiForm, { temaName } from '../../forms/RassilkiForm';
import RassilkaInfo from '../../forms/RassilkaInfo';
import PageLayout from '../../components/PageLayout';
import RassilkaSourceText from '../../forms/RassilkaSourceText';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const { CheckableTag } = Tag;
var _ = require('lodash');

export default function FederationadministratorSettingsSending(props) {
    const { auth } = props;
    const meta = useMetaContext();

    const filters = React.useCallback(() => [
        {
            label: "Дата создания",
            name: "CreatedAt",
            type: "date",
            filterType: "range",
            sort: true,
            filter: true,
            sorted: "DESC",
            filtered: [dayjs().subtract(90, "day"), dayjs().add(5, "day")],
        },
        {   // Тема
            label: "Тема",
            name: "tema",
            filterType: "group",
            display: (o) => o?.nazvanie,
            sort: true,
            filter: true
        },
        {   // Статус
            label: "Статус",
            name: "status",
            filterType: "group",
            display: (o) => o?.nazvanie,
            sort: true,
            filter: true
        },
        {
            label: "Только возобновляемые",
            name: "resumable",
            sort: true,
            filter: true
        },
    ], []);

    return (
        <PageLayout>
            <div style={{ padding: "15px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ paddingTop: "15px" }}>
                    <CollectionServer
                        auth={auth}
                        name={"Rassilka"}
                        source={`/api/rassilka/list`}
                        // contextFilters={() => [
                        //     QueryOrder("isAdmin", "DESC")
                        // ]}
                        subscribe={{
                            name: "service.mailing",
                            // filter: `service.mailing.${uuid}`,
                            func: (data, { msg, collection, setCollection, setCollectionItem, removeCollectionItem, request, state }) => {
                                setCollection(updateInArray(collection, data, true));
                                // request()
                            }
                        }}
                        filters={filters}
                        size={"small"}
                        mode={"list"}
                        render={(e, idx, options) => {
                            return (
                                <div key={idx} style={{ padding: "10px", width: "100%", borderTop: (idx > 0) ? "1px solid #eee" : "none" }}>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ flex: "0 0 30px", textAlign: "center" }}>
                                            {e.statusID === 3 && <div><Icofont icon="check" style={{ color: "green" }} /></div>}
                                            {e.statusID > 3 && <div><Icofont icon="close" style={{ color: "red" }} /></div>}
                                            {e.statusID < 3 && <div style={{ color: "grey", fontSize: "10px", marginTop: "2px" }}>{e.progress}%</div>}
                                            {e.resumable && <div><i className="fa fa-repeat" style={{ color: "orange", fontSize: "10px" }}></i></div>}
                                        </div>
                                        <div style={{ flex: "1 1 auto" }}>
                                            <div style={{ fontSize: "12px", color: "#939393", display: "flex", justifyContent: "start", gap: "5px" }}>
                                                <div className='bg bg-grey' style={{ padding: "0 3px", minHeight: "19px" }}>{dayjs(e.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>
                                                <div style={{ alignSelf: "center" }}>{e?.tema?.nazvanie}</div>
                                                {(e.statusID === 2 && e.errorCode === 0) && <div className={`bg bg-green dark-2`} style={{ color: "green", fontSize: "10px", marginTop: "2px", minHeight: "19px", padding: "0 3px" }}>Выполняется</div>}
                                                {(e.otpravlenoPodpischikam !== e.vsegoPodpischikov) && <div style={{ alignSelf: "center", fontSize: "10px", padding: "0 3px", minHeight: "19px" }}
                                                    className={`bg bg-orange dark-5`}>
                                                    <Icofont icon="user-alt-3" style={{ color: "orange", fontSize: "9px", paddingRight: "4px" }} />
                                                    {`${e.otpravlenoPodpischikam}/${e.vsegoPodpischikov}`}
                                                </div>}
                                                {(e.otpravlenoPodpischikam > 0 && e.otpravlenoPodpischikam === e.vsegoPodpischikov) && <div style={{ alignSelf: "center", fontSize: "10px", padding: "0 3px", minHeight: "19px" }}
                                                    className={`bg bg-green dark-5`}>
                                                    <Icofont icon="user-alt-3" style={{ color: "green", fontSize: "9px", paddingRight: "4px" }} />
                                                    {`${e.otpravlenoPodpischikam}`}
                                                </div>}

                                            </div>
                                            <div style={{ paddingLeft: "2px", maxHeight: "48px", overflow: "hidden" }}>{e.tekst}</div>
                                            {(e.errorCode > 0) &&
                                                <div style={{ paddingLeft: "2px", paddingTop: "5px", display: "flex", gap: "5px", fontSize: "12px" }}>
                                                    <div style={{ flex: "0 0 30px", alignSelf: "start", fontSize: "10px", minHeight: "19px", color: "red" }} className={`bg bg-red dark-5`}>
                                                        Error
                                                    </div>
                                                    <div style={{ flex: "1 1 auto" }}>
                                                        <div>{e.errorMsg}</div>
                                                        <div style={{ color: "#939393" }}>{e.errorException}</div>
                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                            )
                        }}
                        collectionActions={() => [{
                            action: (values, unlock, close, { collection, setCollection }) => {
                                GET(auth, `/api/rassilka/resume/${values?.mailing?.ID}`,
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data))
                                        close()
                                    }, (err) => errorCatch(err, unlock)
                                )
                            },

                            title: "Создать рассылку",
                            modal: { width: "750px" },
                            steps: [
                                {
                                    key: "mailing",
                                    modal: { width: "750px" },
                                    options: {
                                        initialValues: {
                                            temaID: 1,
                                            tekst: ""//`Уважаемый #firstname #lastname! Мы рады сообщить вам о нашем новом мероприятии. Ждем!`
                                        },
                                    },
                                    action: (values, unlock, close, { state }) => {
                                        POSTFormData(auth, `/api/rassilka/${temaName(values?.formaID)}`,
                                            makeFormData(
                                                // { 
                                                //     ...item, 
                                                //     ...values, 
                                                //     preview: "1", 
                                                //     serialized: JSON.stringify({ ...item, ...values }) 
                                                // },
                                                {
                                                    ...state?.mailing,
                                                    ...values,
                                                    // preview: "1", 
                                                    serialized: JSON.stringify({ ...state?.mailing, ...values })
                                                }),
                                            ({ data }) => {
                                                close(data);
                                            }, (err) => errorCatch(err, () => {
                                                unlock(
                                                    { ...err?.object?.data, fileErrors: err?.object?.fileErrors }
                                                )
                                            }));
                                    },
                                    form: RassilkiForm,
                                    okText: "Предварительный просмотр",
                                },
                                {
                                    key: "sending",
                                    okText: "Начать рассылку",
                                    noAntForm: true,
                                    form: (props) => {
                                        return (
                                            <div>
                                                <div>Создаваемая рассылка была только что отправлена Вам!</div>
                                                <div>Убедитесть что содержимое рассылки корректно отображается и вы получили её всеми желаемыми способами.</div>
                                                <div style={{ color: "rgb(143 143 143)", fontSize: "13px" }}>Если всё сработало корректно, то можно начать отправку другим пользователям нажав на кнопку "Начать рассылку"</div>
                                            </div>
                                        )
                                    },
                                }
                            ]
                        },
                        ]}
                        modelActions={(item) => {
                            return [
                                If(item.resumable === true && !(item.statusID === 2 && item.errorCode === 0), {
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        GET(auth, `/api/rassilka/resume/${item?.ID}`,
                                            ({ data }) => {
                                                setCollection(updateInArray(collection, data))
                                                close()
                                            }, (err) => errorCatch(err, unlock)
                                        )
                                    },

                                    title: "Изменить",
                                    modal: { width: "750px" },
                                    steps: [
                                        {
                                            key: "mailing",
                                            modal: { width: "750px" },
                                            object: item,
                                            options: {
                                                initialValues: {
                                                    ...item,
                                                },
                                            },
                                            action: (values, unlock, close) => {
                                                POSTFormData(auth, `/api/rassilka/${temaName(item?.tema?.formaID)}`, makeFormData({
                                                    ...item, ...values,
                                                    // preview: "1", 
                                                    serialized: JSON.stringify({ ...item, ...values })
                                                }),
                                                    ({ data }) => {
                                                        close(data)
                                                    }, (err) => errorCatch(err, () => {
                                                        unlock(
                                                            { ...err?.object?.data, fileErrors: err?.object?.fileErrors }
                                                        )
                                                    }));
                                            },
                                            form: RassilkiForm,
                                            okText: "Предварительный просмотр",
                                        },
                                        {
                                            key: "sending",
                                            okText: "Начать рассылку",
                                            noAntForm: true,
                                            form: (props) => {
                                                return (
                                                    <div>
                                                        <div>Создаваемая рассылка была только что отправлена Вам!</div>
                                                        <div>Убедитесть что содержимое рассылки корректно отображается и вы получили её всеми желаемыми способами.</div>
                                                        <div style={{ color: "rgb(143 143 143)", fontSize: "13px" }}>Если всё сработало корректно, то можно начать отправку другим пользователям нажав на кнопку "Начать рассылку"</div>
                                                    </div>
                                                )
                                            },
                                        }
                                    ]
                                }),
                                If(item.resumable === true, {
                                    title: <span style={{ color: "green" }}>Возобновить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        GET(auth, `/api/rassilka/resume/${item.ID}`,
                                            ({ data }) => setCollection(updateInArray(collection, data)), errorCatch
                                        );
                                    },
                                }),
                                If((item.statusID === 2 && item.errorCode === 0), {
                                    title: <span style={{ color: "red" }}>Остановить</span>,
                                    action: (values, unlock, close, { collection, setCollection }) => {
                                        Modal.confirm({
                                            title: `Вы уверены что хотите остановить рассылку?`,
                                            icon: <ExclamationCircleOutlined />,
                                            // content: <span>{item.nazvanie}</span>,
                                            okText: "Да",
                                            okType: 'danger',
                                            cancelText: "Нет",
                                            onOk: () => {
                                                GET(auth, `/api/rassilka/stop/${item.ID}`,
                                                    ({ data }) => setCollection(updateInArray(collection, data)), errorCatch
                                                );
                                            },
                                        });
                                    },
                                }),
                                {
                                    title: "Информация",
                                    auth: auth,
                                    modal: {
                                        width: "800px",
                                        title: "Информация о рассылке",
                                    },
                                    item: item,
                                    mode: "MenuItem",
                                    action: (values, unlock, close) => {
                                        if (close) close();
                                    },
                                    readonly: true,
                                    form: RassilkaInfo
                                }
                            ]
                        }}
                    />
                </div>
            </div>
        </PageLayout>
    );
}
